import { render, staticRenderFns } from "./photoLib.vue?vue&type=template&id=1c90cfaf&scoped=true"
import script from "./photoLib.vue?vue&type=script&lang=js"
export * from "./photoLib.vue?vue&type=script&lang=js"
import style0 from "./photoLib.vue?vue&type=style&index=0&id=1c90cfaf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c90cfaf",
  null
  
)

export default component.exports